<template>
 <v-container>
        <!-- <v-btn @click=loginFb> 
            Login to FB
        </v-btn> -->
       <v-select
          :items="video_list"
          item-text="title"
          label="Select Video"
          item-value="id"
          @change="change_videoid"
        ></v-select>
        <!-- <v-btn v-for="item in video_list" :key="item.title" @click="change_videoid(item.id)">
            {{ item.title }}
        </v-btn> -->
          <v-btn @click="fetchMsg">
            Fetch Message
        </v-btn>
          <v-chip-group column>
            <v-chip style="white-space:normal;" v-for="item in items2" :key="item.from.name+item.message" v-bind:class="{ height_auto: (item.message.length>43),'py-2': (item.message.length>43) }">
             
                    <v-avatar left>
                      <v-icon color="#4267B2">fab fa-facebook</v-icon>
                      <!-- <v-img :src="require('./assets/logo.png')"></v-img> -->
                    </v-avatar>
                  
                  {{ item.from.name }}
                  <v-subheader ><span>{{ item.message }}
                    </span></v-subheader>
            </v-chip>
          </v-chip-group>   
 </v-container>
</template>
<style>
.height_auto{
    height: auto !important;
    /* padding: 2px 0 !important; */
}
</style>
<script>
// import compareAsc from 'date-fns/compareAsc'
import compareDesc from 'date-fns/compareDesc'
  export default {
    name: "FbSession",
    data(){
      return {
          timer: '',
        // alignment: 'start',
        // dense: false,
        video_list:[],
        video_id:"",
        items3: [
          {name:"ccsy2", message:"text msgtext msgtext adadadsadadasdasdsadsd"},
          {name:"ccsy3", message:"text msg"}
        ],
        items2: [
        //   {name:"ccsy2", message:"text msgtext msgtext adadadsadadasdasdsadsd"},
        //   {name:"ccsy3", message:"text msg"}
        ],
        justify: 'space-between',
      };
    },
    mounted(){
        // this.items.$set(0,{name:'adasdas'});
        // console.log(this.items);
        this.timer = setTimeout(this.fetchMsg2, 5000);
        // window.fbAsyncInit = () => {
        //   window.FB.init({
        //     appId            : '259719201765256',
        //     autoLogAppEvents : true,
        //     xfbml            : true,
        //     version          : 'v7.0',
        //     start: "set HTTPS=true&&react-scripts start"
        //   });
        // }
        var loginToken;
          window.fbAsyncInit = () => {
            console.log("---log in fb2");
            window.FB.init({
              appId            : '259719201765256',
              autoLogAppEvents : true,
              xfbml            : true,
              version          : 'v7.0',
              start: "set HTTPS=true&&react-scripts start"
            });
        
          
          window.FB.getLoginStatus((response) => {
                if (response.status === 'connected') {
                    var uid = response.authResponse.userID;
                    // var video_id;
                    loginToken = response.authResponse.accessToken;
                    console.log(loginToken);
                    console.log(uid);
                    window.FB.api('/me', (response) => {
                            console.log('15Good to see you, ' + response.name + '.');
                    });
                    window.FB.api('/me/live_videos', (response)=> {
                            console.log(response.data);
                            // var live_video_list = response.data;
                            this.video_list = response.data;
                            // for(var i=0;i<live_video_list.length;i++){
                            //     video_id = live_video_list[i].id;
                            //     console.log(live_video_list[i].id);
                                // window.FB.api('/'+video_id+"/comments", (response) =>{
                                //         console.log("haha");
                                //         console.log(response.data);
                                //         var video_comments = response.data;
                                //         // $set(this.items2, response.data);
                                //         this.items2 = response.data;
                                //         this.items2.sort((a, b) => compareDesc(new Date(a.created_time), new Date(b.created_time)))
                                //         console.log("this items");
                                //         console.log(this.items2)
                                //         // console.log(video_comments);
                                //         for(var i=0;i<video_comments.length;i++){
                                //             console.log(video_comments[i].from.name);
                                //             console.log(video_comments[i].message);
                                //         }
                                // });
                            // }
                    });
                    
                }else if (response.status === 'not_authorized') {
                    
                    window.FB.login(function(response) {
                    if (response.authResponse) {
                        window.FB.getLoginStatus(function(response) {
                            if (response.status === 'connected') {
                                console.log(response.authResponse.accessToken);
                            }
                        });
                        console.log('Welcome!  Fetching your information.... ');
                        window.FB.api('/me', function(response) {
                            console.log('Good to see you, ' + response.name + '.');
                        });
                        } else {
                        console.log('User cancelled login or did not fully authorize.');
                        }
                     });
                     console.log("not_authorized");
                }else{
                    window.FB.login(function(response) {
                    if (response.authResponse) {
                        window.FB.getLoginStatus(function(response) {
                            if (response.status === 'connected') {
                                console.log(response.authResponse.accessToken);
                            }
                        });
                        console.log('Welcome!  Fetching your information.... ');
                        window.FB.api('/me', function(response) {
                            console.log('Good to see you, ' + response.name + '.');
                        });
                        } else {
                        console.log('User cancelled login or did not fully authorize.');
                        }
                     });
                    console.log("not_authorized2");
                }
            });
         
           
          };
         (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    },
    beforeDestroy() {
      // clearTimeout(this.timer);
    },
    methods: {
      fetchMsg2:function(){
        console.log("--fetch2");
          if(this.video_id != ""){
            this.fetchMsg();
          }
          this.timer = setTimeout(this.fetchMsg2, 20000);
      },
      fetchMsg:function() {
         console.log("fetch msg");

        window.FB.api('/'+this.video_id+"/comments", (response) =>{
                console.log("haha");
                console.log(response.data);
                var video_comments = response.data;
                // $set(this.items2, response.data);
                this.items2 =[];
                this.items2 = response.data;
                console.log("this items");
                console.log(this.items2)
                this.items2.sort((a, b) => compareDesc(new Date(a.created_time), new Date(b.created_time)))
                console.log("this items2");
                console.log(this.items2)
                // console.log(video_comments);
                for(var i=0;i<video_comments.length;i++){
                    console.log(video_comments[i].created_time +" "+video_comments[i].message);
                    // console.log(video_comments[i].message);
                }
        });

      },
      change_videoid: function(id){
        console.log("----change id");
        console.log(id);
        this.video_id = id;
        console.log(this.video_id);
        this.fetchMsg();
      },
      // loginFb: function(){
      //   console.log("---log in fb");

      //     window.FB.getLoginStatus((response) => {
      //           if (response.status === 'connected') {
      //               var uid = response.authResponse.userID;
      //               // var video_id;
      //               loginToken = response.authResponse.accessToken;
      //               console.log(loginToken);
      //               console.log(uid);
      //               window.FB.api('/me', (response) => {
      //                       console.log('15Good to see you, ' + response.name + '.');
      //               });
      //               window.FB.api('/me/live_videos', (response)=> {
      //                       console.log(response.data);
      //                       // var live_video_list = response.data;
      //                       this.video_list = response.data;
      //                       // for(var i=0;i<live_video_list.length;i++){
      //                       //     video_id = live_video_list[i].id;
      //                       //     console.log(live_video_list[i].id);
      //                           // window.FB.api('/'+video_id+"/comments", (response) =>{
      //                           //         console.log("haha");
      //                           //         console.log(response.data);
      //                           //         var video_comments = response.data;
      //                           //         // $set(this.items2, response.data);
      //                           //         this.items2 = response.data;
      //                           //         this.items2.sort((a, b) => compareDesc(new Date(a.created_time), new Date(b.created_time)))
      //                           //         console.log("this items");
      //                           //         console.log(this.items2)
      //                           //         // console.log(video_comments);
      //                           //         for(var i=0;i<video_comments.length;i++){
      //                           //             console.log(video_comments[i].from.name);
      //                           //             console.log(video_comments[i].message);
      //                           //         }
      //                           // });
      //                       // }
      //               });
                    
      //           }else if (response.status === 'not_authorized') {
                    
      //               window.FB.login(function(response) {
      //               if (response.authResponse) {
      //                   window.FB.getLoginStatus(function(response) {
      //                       if (response.status === 'connected') {
      //                           console.log(response.authResponse.accessToken);
      //                       }
      //                   });
      //                   console.log('Welcome!  Fetching your information.... ');
      //                   window.FB.api('/me', function(response) {
      //                       console.log('Good to see you, ' + response.name + '.');
      //                   });
      //                   } else {
      //                   console.log('User cancelled login or did not fully authorize.');
      //                   }
      //                });
      //                console.log("not_authorized");
      //           }else{
      //               window.FB.login(function(response) {
      //               if (response.authResponse) {
      //                   window.FB.getLoginStatus(function(response) {
      //                       if (response.status === 'connected') {
      //                           console.log(response.authResponse.accessToken);
      //                       }
      //                   });
      //                   console.log('Welcome!  Fetching your information.... ');
      //                   window.FB.api('/me', function(response) {
      //                       console.log('Good to see you, ' + response.name + '.');
      //                   });
      //                   } else {
      //                   console.log('User cancelled login or did not fully authorize.');
      //                   }
      //                });
      //               console.log("not_authorized2");
      //           }
      //       });
      // },
      
    },
    computed: {
      
    }
  }
</script>

      